import { render, staticRenderFns } from "./FinishSignup.vue?vue&type=template&id=5312a484&scoped=true&"
import script from "./FinishSignup.vue?vue&type=script&lang=js&"
export * from "./FinishSignup.vue?vue&type=script&lang=js&"
import style0 from "./FinishSignup.vue?vue&type=style&index=0&id=5312a484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5312a484",
  null
  
)

export default component.exports